import { render, staticRenderFns } from "./BaseBeatmap.vue?vue&type=template&id=ae8e3854&"
import script from "./BaseBeatmap.vue?vue&type=script&lang=js&"
export * from "./BaseBeatmap.vue?vue&type=script&lang=js&"
import style0 from "./BaseBeatmap.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports